module.exports = __webpack_public_path__ + "static/img/airoad_img3.412b5dbb.png";